<div class="loading-container">
    <div class="loading-header mb-3">Measuring ...</div>
    <div>
        @for (state of loadingStates; track state; let i = $index) {
            <div class="step" [ngClass]="{ completed: currentStep() > i, active: currentStep() === i }">
                <div class="step-container">
                    <div class="v-stepper">
                        <div class="circle"></div>
                        <div class="line"></div>
                    </div>
                    <div class="step-name">{{ state }}</div>
                </div>

                <div class="content">
                    @if (currentStep() > i) {
                        <span class="completed-icon ml-3">
                            <i class="fa fa-check"></i>
                        </span>
                    }
                    @if (currentStep() === i) {
                        <span class="progress">in progress</span>
                        <i class="fa-light fa-loader fa-spin spinner"></i>
                    }

                    @if (currentStep() < i) {
                        <span class="ellipse ml-3"></span>
                    }
                </div>
            </div>
        }
    </div>

    <button type="button" id="stop-generating-ai-takeoffs" class="btn-bx-primary btn-large full-width mt-3" (click)="stopGeneration()">
        @if (isLoadingComplete) {
            Dismissing...
        } @else {
            <span class="stop-icon mr-2"></span>
            <span class="vertical-align-middle">Stop generating</span>
        }
    </button>
</div>
